// extracted by mini-css-extract-plugin
module.exports = {"Progress":"Progress--1A8i3"};